import { render } from "./ProjectOverviewHub.vue?vue&type=template&id=6d8e147a&scoped=true"
import script from "./ProjectOverviewHub.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewHub.vue?vue&type=script&lang=js"

import "./ProjectOverviewHub.vue?vue&type=style&index=0&id=6d8e147a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8e147a"]])

export default __exports__